import { computed, get } from '@ember/object';

export default function lessThanProperty(dependentKey, deltaKey) {
  return computed(dependentKey, deltaKey, function () {
    return get(this, dependentKey) < get(this, deltaKey);
  });
}
